
import NotFound from '../components/components/NotFound'
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
// import Error from 'next/error'
const CustomeError=()=>(
    <NotFound />
)


// export async function getServerSideProps({res, locale,req}) {
//     res.statusCode=410
  
    
//     return {
//       props: {

//         ...(await serverSideTranslations(locale, ["common"]))
//       }
//     };
//   }
  export default CustomeError